<template>
  <div>
    <div
      v-if="$localized(current, 'inner_context')"
      class="text-center px-5 py-4 mt-16 mt-md-8"
    >
      {{ $localized(current, 'inner_context') }}
    </div>

    <QuizScenario :scenario="current.scenario" />

    <div class="quiz-bubble">
      <v-card
        rounded="lg"
        class="quiz-text mx-6 mt-0 mb-4 px-6 py-4 custom-elevation"
      >
        {{ $localized(current, 'text') }}
      </v-card>
    </div>
  </div>
</template>

<style scoped>
.quiz-text:before {
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid white;
  content: ' ';
  height: 0;
  left: calc(50% - 16px);
  position: absolute;
  top: -16px;
  width: 0;
}
</style>

<script>
import QuizScenario from '@/components/games/quiz/QuizScenario.vue';

export default {
  name: 'QuizHome',
  components: {
    QuizScenario,
  },
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
